<template>
  <button
    :class="`circular-progress-button ${is_disabled ? 'circular-progress-tone-down' : ''}`"
    :disabled="is_disabled"
    :style="`
      ${ items_per_row
        ?
          `width: calc((100% - ${(items_per_row-1) * 8}px) / ${items_per_row});
          aspect-ratio: 1 / 1;`
        :
          `width: ${button_width || 64}px;
          height: ${button_width || 64}px;`
      }
    `"
    @click="$emit('emittedClick');"
  >
    <div class="circular-progress-button-dummy-height" v-if="items_per_row"/>
    <!-- PROGRESS CIRCLE -->
    <v-progress-circular
      class="circular-no-underlay circular-no-transition circular-progress-button-progess-circle"
      :value="progress_zero ? 0 : value"
      :width="width"
      :color="foreground_color"
      rotate="-90"
    >
      <!-- INNER CIRCLE WITH ICON -->
      <div
        class="circular-progress-button-icon-container"
        :style="`
          border: 1px solid ${has_no_tasks
            ? `${getTranspHexColor(foreground_color, .25)}`
            : `${background_color}`
          };
          background-color: ${is_completed ? `${foreground_color}` : ''}`"
      >
        <TIcon
          :name="icon"
          :color="is_completed ? background_color : foreground_color"
        />
      </div>
    </v-progress-circular>

    <!-- PROGRESS CIRCLE UNDERLAY -->
    <transition name="circular-progress-fade">
      <v-progress-circular
        v-if="!has_no_tasks"
        class="circular-progress-underlay circular-no-underlay circular-no-transition circular-progress-button-progess-circle"
        :value="100"
        :width="width"
        :color="getTranspHexColor(foreground_color, .25)"
        rotate="-90"
      />
    </transition>

    <!-- HIGHLIGHT -->
    <div
      v-if="is_marked"
      class="circular-progress-highlight"
      :style="`background-color: ${is_completed ? background_color : foreground_color};`"
    />
  </button>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    mixins: [
      TColor,
    ],

    components: {
      TIcon,
    },

    props: [
      'icon', // is string, contains icon
      'value', // is number, contains progress in form of 0 to 100
      'has_no_tasks', // is boolean, toggles special display of empty step category
      'is_disabled', // is boolean, toggles disabled and special display of filtered out step category
      'size', // is number, contains size of the v-progress-circular
      'width', // is number, contains width of v-progress-circular circle
      'button_width', // is number, contains width of button if items_per_row is not set
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'items_per_row', // is number, contains expected number of items per row to control width
      'is_marked', // is boolean, toggles point to highlight
    ],

    computed: {
      is_completed() {
        return this.value >= 100;
      },
    },

    data: () => ({
      progress_zero: true,
    }),

    methods: {
      // TODO: SVG-Icons
      // <svg-icon
      //   v-else-if="workpackage_icon"
      //   class="svg-icon"
      //   :name="workpackage_icon"
      //   :size="workpackage_count > 2?14:20"
      //   :style="`
      //     ${zoom?`zoom: ${zoom};`:''}
      //     color: black;
      //     height: 20px;
      //     `"
      // />
    },

    mounted() {
      let self = this;
      self.progress_zero = true;
      setTimeout(function () {
        self.progress_zero = false;
        }, 1);
    },
  }
</script>

<style>
.circular-progress-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  outline: none;
  flex-shrink: 0;
}
.circular-progress-button-progess-circle {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100% !important;
  width: 100% !important;
}
.circular-progress-tone-down {
  /* use this to tone down steps that got filtered out */
  opacity: .33;
}
.circular-progress-button-icon-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  /* transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out; */
  border-radius: 100%;
  width: 75%;
  height: 75%;
}
.circular-progress-underlay {
  position: absolute;
  left: 0;
}
.circular-no-underlay .v-progress-circular__underlay  {
  stroke: rgba(0, 0, 0, 0);
}
.circular-no-transition .v-progress-circular__overlay {
  transition:
    stroke-dashoffset 0.3s ease-in-out;
}
.circular-progress-fade-enter-active, .circular-progress-fade-leave-active {
  transition: opacity .3s;
}
.circular-progress-fade-enter, .circular-progress-fade-leave-to {
  opacity: 0;
}
.circular-progress-button-dummy-height {
  padding-top: 100%;
}
.circular-progress-highlight {
  position: absolute;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  transform: translateY(16px);
}
</style>
